import React, { CSSProperties, ReactNode } from 'react';
import { Typography, ETypographySize, IconPopup } from '../../index';
import { useViewport } from '../../hooks/useViewport';

export interface IHelpContent {
	title: string;
	id: string;
}

interface IHeadProps {
	headline: string;
	description?: string | React.ReactNode;
	headlineSize?: keyof typeof ETypographySize;
	helpContent?: IHelpContent;
	classNameDescription?: string;
	classNameHeadline?: string;
	wrapperClass?: string;
	wrapperStyle?: CSSProperties;
	trackingElement?: string;
	children?: ReactNode;
}

export const Head = ({
	headline,
	description,
	headlineSize = 'h3',
	wrapperClass = '',
	classNameDescription = '',
	classNameHeadline = '',
	helpContent,
	wrapperStyle,
	trackingElement,
	children,
}: IHeadProps) => {
	const { viewport } = useViewport();
	return (
		<div
			className={`mb-6 px-4 md:mb-8 md:px-0 md:flex md:items-center md:self-center md:flex-col md:w-10/12 ${wrapperClass}`}
			style={wrapperStyle}>
			<Typography
				variant="header"
				size={headlineSize}
				component="h2"
				color="title"
				className={`inline-block relative md:text-center ${classNameHeadline}`}>
				{headline}
				{helpContent && (
					<IconPopup
						bold
						contentfulId={helpContent.id}
						buttonStyle="absolute bottom-[3px] ml-1.5 md:bottom-[9px]"
						iconSize={viewport === 'desktop' ? '32' : '24'}
						title={helpContent.title}
						trackingElement={trackingElement}
						type="info"
						paddingX="large"
					/>
				)}
				{children}
			</Typography>
			{description && (
				<Typography size="lg" component="p" className={`pt-3 md:text-center md:w-6/12 ${classNameDescription}`}>
					{description}
				</Typography>
			)}
		</div>
	);
};
